import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

export default {
  state: () => ({
    selectedSpecialServiceRequestCategory: {},
  }),

  mutations: {
    setSelectedSpecialServiceRequestCategory(state, specialServiceRequestCategory) {
      Vue.set(state, "selectedSpecialServiceRequestCategory", specialServiceRequestCategory);
    },
  },
  actions: {
    //TODO: load, update, create
    createSpecialServiceRequestCategory: (context, request) => {
      //TODO: Loader start
      return axios
        .post(context.getters.getMcServiceUrl + "/special-service-request-categories/entity", request, {})
        .then((response) => {
          //TODO: Loader end
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadSpecialServiceRequestCategories: (context) => {
      //TODO: Loader start
      return axios.get(context.getters.getMcServiceUrl + "/special-service-request-categories/entity").then((response) => {
        return response.data;
      });
    },
    loadPublishedSpecialServiceRequestCategories: (context) => {
      //TODO: Loader start
      return axios.get(context.getters.getMcServiceUrl + "/special-service-request-categories/entity/published").then((response) => {
        //TODO: Loader koyulacak
        return response.data;
      });
    },
    loadSpecialServiceRequestCategory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/special-service-request-categories/entity/" + request.id).then((response) => {
        return response.data;
      });
    },
    loadSpecialServiceRequestCategoryHistory: (context, request) => {
      //TODO: Loader start
      return axios.post(context.getters.getMcServiceUrl + "/special-service-request-categories/entity/history/search", request, {}).then((response) => {
        //TODO: Loader end
        return response.data;
      });
    },
    loadSelectedSpecialServiceRequestCategoryHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/special-service-request-categories/history/" + request.id, {}).then((response) => {
        return response.data;
      });
    },
    deleteSpecialServiceRequestCategory: (context, specialServiceRequestCategory) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/special-service-request-categories/entity/" + specialServiceRequestCategory.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          specialServiceRequestCategory.intents = intents;
          specialServiceRequestCategory.intentId = response.data.id;
          return specialServiceRequestCategory;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftSpecialServiceRequestCategory: (context, specialServiceRequestCategory) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/special-service-request-categories/draft/" + specialServiceRequestCategory.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    publishSpecialServiceRequestCategory: (context, specialServiceRequestCategory) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/special-service-request-categories/publish/" + specialServiceRequestCategory.intentId)
        .then((response) => {
          if (response.data) {
            response.data.intentId = 0;
          }
          return response.data;
        });
    },
    rejectSpecialServiceRequestCategory: (context, specialServiceRequestCategory) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/special-service-request-categories/reject/" + specialServiceRequestCategory.intentId)
        .then((response) => {
          if (specialServiceRequestCategory.intents[0].type === "DELETE_ADDITIONAL_SERVICE_TYPE") {
            specialServiceRequestCategory.intents = null;
            specialServiceRequestCategory.intentId = 0;
          } else if (specialServiceRequestCategory.intents[0].type === "CREATE_ADDITIONAL_SERVICE_TYPE") {
            specialServiceRequestCategory.intents[0].status = "DRAFT";
          } else if (specialServiceRequestCategory.intents[0].type === "UPDATE_ADDITIONAL_SERVICE_TYPE") {
            specialServiceRequestCategory.intents[0].status = "DRAFT";
          }
          return response.data;
        });
    },
    sendToApprovalSpecialServiceRequestCategory: (context, specialServiceRequestCategory) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/special-service-request-categories/sendToApproval/" + specialServiceRequestCategory.intentId)
        .then((response) => {
          if (specialServiceRequestCategory.intents[0].type === "CREATE_ADDITIONAL_SERVICE_TYPE") {
            specialServiceRequestCategory.intents[0].status = "WAITING_APPROVAL";
          } else if (specialServiceRequestCategory.intents[0].type === "UPDATE_ADDITIONAL_SERVICE_TYPE") {
            specialServiceRequestCategory.intents[0].status = "WAITING_APPROVAL";
          }
          return response.data;
        });
    },

    recallSpecialServiceRequestCategory: (context, specialServiceRequestCategory) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/special-service-request-categories/recall/" + specialServiceRequestCategory.intentId)
        .then((response) => {
          helper.recallOrRejectEntity(specialServiceRequestCategory, "ADDITIONAL_SERVICE_TYPE");
          return response.data;
        });
    },

    cancelSpecialServiceRequestCategory: (context, specialServiceRequestCategory) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/special-service-request-categories/cancel/" + specialServiceRequestCategory.intentId)
        .then((response) => {
          return response.data;
        });
    },
  },
  getters: {
    getSelectedSpecialServiceRequestCategory: (state) => {
      return state.selectedSpecialServiceRequestCategory;
    },
  },
};
